// extracted by mini-css-extract-plugin
export default {"parentIssuesList":"ParentIssueAddedEvent-module__parentIssuesList--mKImF","parentIssueItem":"ParentIssueAddedEvent-module__parentIssueItem--geDWe"};